import React, { useContext, useState } from "react";
import { AiOutlineSafetyCertificate ,AiOutlineHeart} from 'react-icons/ai';
import {GiMoneyStack,GiPodiumWinner} from 'react-icons/gi'
import styles from './loginSingup.module.css'
import { ThemeContext } from "../../context/themeContext";
import Login from "./login";
import Singup from "./signup";
import { LoginSingupPageContext } from "../../context/loginSingupPageContext";
import FooterLink from "../../components/FooterLinks";
const LoginSingup = ()=>{


const {handleThemeChange}=useContext(ThemeContext);
const {pageState,setPageState}=useContext(LoginSingupPageContext);





    return(
        <div style={{backgroundColor:"var(--secondry-bg-color",height:"100vh",minHeight:"100%"}}>
           
   <div className={styles.mianContainer}>
        <div className={styles.card}>
            <div className={styles.left}>
                <div className={styles.heading}>
                    <h1>Join Vsam</h1>
                    
                </div>
                <div className={styles.tagline}>Live Your Pa$$ion Everyday</div>
                <div className={styles.point}>
                    <div className={styles.iconBox}>
                <GiMoneyStack size="30px"/>
                </div>
                Earn money by showing your Passion
                </div>
                <div className={styles.point}>
                <div className={styles.iconBox}>
                <AiOutlineSafetyCertificate size="30px"/>
                 </div>
                Accreditation of your talent and skills
                </div>
                <div className={styles.point}>
                <div className={styles.iconBox}>
                <GiPodiumWinner size="30px"/>
                 </div>
                 Want to pursue your talent and skills        

                </div>
                <div className={styles.point}>
                <div className={styles.iconBox}>
                <AiOutlineHeart size="30px"/>
                 </div>
                 Live new social networking life
                </div>

            </div>
            <div className={styles.right}>
            {pageState==="login"?( <Login/>):""}
            {pageState==="signup"?( <Singup/>):""}
               
                

            </div>
        </div>
        
    </div>
    <FooterLink/>
    </div>
      
)
}

export default LoginSingup;